import React from "react";
import {DefaultButton, Icon, PrimaryButton, Stack, Text} from "@fluentui/react";
import {useTranslation} from "react-i18next";

import styles from "./IsaacConfirmationModal.module.scss";
import type IsaacConfirmationModalProps from "./IsaacConfirmationModalProps";
import IsaacModal from "../isaacModal/IsaacModal";

const IsaacConfirmationModal: React.FC<IsaacConfirmationModalProps> = ({
  isOpen,
  confirmationText,
  detailsText,
  onConfirm,
  onDismiss,
}) => {
  const {t} = useTranslation(["common"]);

  const handleConfirm = (): void => {
    onConfirm();
  };
  const handleDismiss = (): void => {
    onDismiss();
  };

  return (
    <IsaacModal
      isOpen={isOpen}
      handleDismiss={handleDismiss}
      containerClassName={styles.container}
      overlay={{className: styles.overlay}}>
      <Stack>
        <Stack verticalAlign="center" horizontalAlign="center">
          <Icon iconName="Warning" className={styles.icon} />
          <Text variant="xLargePlus">
            {confirmationText ?? t("confirmationText")}
          </Text>
        </Stack>
        <Stack
          verticalAlign="center"
          horizontalAlign="center"
          className={styles.body}>
          <Text variant="large">{detailsText ?? t(`detailsText`)}</Text>
        </Stack>
        <Stack horizontal className={styles.footer}>
          <Stack.Item className={styles.button}>
            <PrimaryButton onClick={handleConfirm} text={t("confirm")} />
          </Stack.Item>
          <Stack.Item className={styles.button}>
            <DefaultButton onClick={handleDismiss} text={t("cancel")} />
          </Stack.Item>
        </Stack>
      </Stack>
    </IsaacModal>
  );
};

export default IsaacConfirmationModal;
